export default __webpack_public_path__ + "static/car-bike-52b03da61c0c8a81ec9265adc3972d81.png";